import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15;
export default {
    services: {
        createCustomer: (customer, type = "complete", token = "") => {
            return axios(token).post(`/customers?origin=rhombuss-operator&type=${type}`, customer)
        },
        getCustomers: (limit = 15, page = 1, query = "", token = "") => {
            return axios(token).get(`/customers?limit=${limit}&page=${page}${query ? `&${query}` : ""}`)
        },
        getCustomerById: (customerId, token = "") => {
            return axios(token).get(`/customers/${customerId}`)
        },
        updateCustomerById: (customerId, customer, token = "") => {
            return axios(token).put(`/customers/${customerId}`, customer)
        },
        deleteCustomerById: (customerId, token = "") => {
            return axios(token).delete(`/customers/${customerId}`)
        },
        deleteManyCustomersById: (customers, token = "") => {
            return axios(token).post(`/bulk-delete-customers`, customers)
        },
        customerOptions: (token = "") => {
            return axios(token).get(`/customers-options`)
        },

    }
}